

import React, { useState, useEffect, useContext } from 'react';
import {
    Box, Typography, Grid, TextField, Checkbox, FormControlLabel,
    Button, CircularProgress, Divider,
    Autocomplete,
    Chip
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Context from '../../context/Context';
import { Trash2 } from 'lucide-react';
import apiClient from '../../utils/apiClient';
const AddEditPackageServices = () => {
    const { services, getServices } = useContext(Context);
    const location = useLocation();
    const navigate = useNavigate();
    const { isEditMode, service } = location.state || {};

    // const [selectedServiceIds, setSelectedServiceIds] = useState([]);
    const [selectedServices, setSelectedServices] = useState([]);

    const [formData, setFormData] = useState({
        id: '',
        name: '',
        description: '',
        price: '',
        serviceImg: null,
        isActive: false,
        isDeleted: false,
        sequenceOrder: null,
    });
    const [imagePreview, setImagePreview] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [validateErrors, setValidateErrors] = useState({})

    // Populate form on edit
    useEffect(() => {
        if (service) {
            setFormData({
                id: service.id || '',
                name: service.name || '',
                description: service.description || '',
                price: service.price || '',
                serviceImg: null,
                isActive: service.isActive || false,
                isDeleted: service.isDeleted || false,
                sequenceOrder: service.sequenceOrder || '',
            });
            const currentServiceIds = Array.isArray(service?.servicePackages)
                ? service.servicePackages.map(s => ({
                    serviceId: s.serviceId,
                    id: s.id,
                    name: s.serviceName || ''
                }))
                : [];
            setSelectedServices(currentServiceIds);

            // If image URL is present (string), set as preview
            if (service.serviceImg && typeof service.serviceImg === 'string') {
                setImagePreview(service.serviceImg);
            } else if (service.imageUrl) {
                // Or if imageUrl prop exists in your data
                setImagePreview(service.imageUrl);
            }
        }
    }, [service]);

    const handleServiceSelect = (e, newValue) => {
        setSelectedServices(newValue);
        setValidateErrors(prev => ({ ...prev, services: '' }));
        setError('');
    };


    const handleServiceDelete = async (serviceToDelete) => {
        if (!serviceToDelete.id) {
            setSelectedServices(prev => prev.filter(s => s.serviceId !== serviceToDelete.serviceId));
            return;
        }

        try {
            setLoading(true);
            const response = await apiClient.delete(`/packages/package/service/${serviceToDelete.id}`);
            if (response?.data?.status === true) {
                toast.success(response?.data?.message || "Service deleted successfully");
                setSelectedServices(prev => prev.filter(s => s.serviceId !== serviceToDelete.serviceId));
            } else {
                setError(response?.data?.message || "Failed to delete service");
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Error deleting service");
        } finally {
            setLoading(false);
        }
    };

    const options = services.map(service => {
        const existing = selectedServices.find(s => s.serviceId === service.id);
        return existing ? existing : { id: null, serviceId: service.id, name: service.name };
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (['price', 'sequenceOrder'].includes(name)) {

            if (value === '' || /^[0-9\b]+$/.test(value)) {
                setFormData(prev => ({ ...prev, [name]: value }));
                setValidateErrors(prev => ({ ...prev, [name]: '' }))

            }
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
            setValidateErrors(prev => ({ ...prev, [name]: '' }))
        }
        setError('');
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    const handleImageFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData((prev) => ({ ...prev, serviceImg: file }));
            setImagePreview(URL.createObjectURL(file));
            setValidateErrors(prev => ({ ...prev, serviceImg: '' }));
            setError('');
        } else if (!imagePreview) {
            setFormData((prev) => ({ ...prev, serviceImg: null }));
            setValidateErrors(prev => ({ ...prev, serviceImg: 'Please upload a valid image' }));
        }
    };


    const validateForm = () => {
        const errors = {};

        if (!formData.name?.trim()) errors.name = "Name is required";
        if (!formData.description?.trim()) errors.description = "Description is required";
        if (!formData.price || isNaN(formData.price)) errors.price = "Valid price is required";
        if (!formData.sequenceOrder || isNaN(formData.sequenceOrder)) errors.sequenceOrder = "Valid sequence order is required";
        if (selectedServices.length < 2) errors.services = 'Please select at least two services';

        if (!formData.serviceImg && !imagePreview) errors.serviceImg = "Please upload a valid image";
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setValidateErrors(errors);
            return;
        }
        setLoading(true);
        try {
            const payload = new FormData();
            payload.append('id', formData.id);
            payload.append('name', formData.name);
            payload.append('description', formData.description);
            payload.append('price', formData.price)

            if (formData.serviceImg instanceof File) {
                payload.append('packageImage', formData.serviceImg);
            } else if (typeof imagePreview === 'string') {
                payload.append('packageImage', imagePreview);
            }
            payload.append('isActive', formData.isActive);

            payload.append('sequenceOrder', formData.sequenceOrder);
            payload.append('services', JSON.stringify(selectedServices.map(s => ({
                serviceId: s.serviceId,
                // id: s.id || null, // Use existing id if available
                serviceName: s.name || ''
            }))));

            // const response = isEditMode
            //     ? await axios.put(`${apiUrl}/packages/updatepackageservices/${formData.id}`, payload
            //     )
            //     : await axios.post(`${apiUrl}/packages/createpackageservices`, payload);

const response = isEditMode
  ? await apiClient.put(
      `/packages/updatepackageservices/${formData.id}`,
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  : await apiClient.post(
      '/packages/createpackageservices',
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

            if (response.data.status === true) {
                navigate(-1);
                toast.success(response.data.message)
            } else {
                setError(response?.data?.message || 'Failed to save package service. Please try again.');
            }
        } catch (err) {
            setError(err?.response?.data?.message||'Something went wrong. Please try again later.');
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        getServices()
    }, [])

    return (
        <><Box sx={{ p: { xs: 2, sm: 2 } }}>
            <Typography variant="h4" fontWeight={400} mb={2} >
                {isEditMode ? `Edit Package Service - ${formData.name}` : 'Add New Package Service'}
            </Typography>
            <Divider sx={{ mb: 1 }} />

            <form onSubmit={handleSubmit} >
                <Grid container spacing={2}>

                    {/* Image Upload */}
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body1" fontWeight={500} gutterBottom>
                            Service Image
                        </Typography>
                        <Box
                            sx={{
                                width: 120,
                                height: 120,
                                borderRadius: 2,
                                bgcolor: 'primary.background',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: validateErrors.serviceImg ? '1px solid red' : '1px dashed gray',
                                mb: 1,
                            }}
                        >
                            {imagePreview ? (
                                <img
                                    src={imagePreview}
                                    alt="Preview"
                                    style={{ width: '110px', height: '110px', borderRadius: 4 }}
                                />
                            ) : (
                                <Typography variant="caption">No Image</Typography>
                            )}
                        </Box>

                        <label htmlFor="upload-img">
                            <input
                                type="file"
                                id="upload-img"
                                hidden
                                accept="image/*"
                                onChange={handleImageFileChange}
                            />
                            <Button variant="outlined" component="span" type="button">
                                Upload Image
                            </Button>
                        </label>
                        {validateErrors.serviceImg && (
                            <Typography color="error" variant="body2" sx={{ mt: 0.5 }}>
                                {validateErrors.serviceImg}
                            </Typography>
                        )}
                    </Grid> <br />

                    {/* Name */}
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            label="Name"
                            name="name"

                            fullWidth
                            size="small"
                            value={formData.name}
                            onChange={handleInputChange}
                            error={!!validateErrors.name}
                            helperText={validateErrors.name}
                        />
                    </Grid>

                    {/* Description */}
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            label="Description"
                            name="description"

                            fullWidth
                            size="small"
                            value={formData.description}
                            onChange={handleInputChange}
                            error={!!validateErrors.description}
                            helperText={validateErrors.description}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            label="Price"
                            name="price"

                            fullWidth
                            size="small"
                            value={formData.price}
                            onChange={handleInputChange}
                            error={!!validateErrors.price}
                            helperText={validateErrors.price}
                        />
                    </Grid>

                    {/* Sequence Order */}
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            label="Sequence Order"
                            name="sequenceOrder"

                            fullWidth
                            size="small"
                            value={formData.sequenceOrder}
                            onChange={handleInputChange}
                            error={!!validateErrors.sequenceOrder}
                            helperText={validateErrors.sequenceOrder}
                        />
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 6 }}>
                        <Autocomplete
                            size='small'
                            multiple
                            options={options}
                            getOptionLabel={(option) => option.name}
                            value={selectedServices}
                            onChange={handleServiceSelect}
                            filterSelectedOptions
                            disableCloseOnSelect
                            isOptionEqualToValue={(option, value) => option.serviceId === value.serviceId}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip
                                        label={option.name}
                                        {...getTagProps({ index })}
                                        key={option.serviceId}
                                        onDelete={() => handleServiceDelete(option)}
                                        deleteIcon={<Trash2 size={16} />}
                                    />
                                ))
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label="Select Services"
                                    placeholder="Select multiple services"
                                    error={!!validateErrors.services}
                                    helperText={validateErrors.services}
                                />
                            )}
                        />
                    </Grid>

                    {/* Checkboxes */}
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="isActive"
                                    checked={formData.isActive}
                                    onChange={handleCheckboxChange}
                                    size="small"
                                />
                            }
                            label="Is Active"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="isDeleted"
                                    checked={formData.isDeleted}
                                    onChange={handleCheckboxChange}
                                    size="small"
                                />
                            }
                            label="Is Deleted"
                        />
                    </Grid>

                    {/* Error Message */}
                    {error && (

                        <Typography color="error" textAlign="left">
                            {error}
                        </Typography>

                    )}

                    {/* Submit Button */}
                    <Grid size={{ xs: 12 }}>
                        <Box display="flex" justifyContent="end" mt={2} gap={2}>
                            <Button variant="outlined" color="primary" onClick={() => navigate(-1)}>
                                Cancel
                            </Button>
                            <Button type="submit" variant="contained" disabled={loading}>
                                {loading ? (
                                    <CircularProgress size={24} sx={{ color: '#fff' }} />
                                ) : (
                                    isEditMode ? 'Update' : 'Create'
                                )}
                            </Button>
                        </Box>
                    </Grid>

                </Grid>
            </form>
        </Box>
        </>
    )
}

export default AddEditPackageServices
